import { reactive } from 'vue';

export const transactionModalState = reactive({
    isOpen: false,
    data: null,
    onSuccess: null,

    open(data = null, callback = null) {
        this.data = data ? JSON.parse(JSON.stringify(data)) : null;
        this.onSuccess = callback;
        this.isOpen = true;
    },

    close() {
        this.isOpen = false;
        this.data = null;
        this.onSuccess = null;
    },

    // A única função dele é executar o callback da listagem
    notifySuccess() {
        if (typeof this.onSuccess === 'function') {
            this.onSuccess();
        }
    }
});